export default __webpack_public_path__ + "static/media/refectori-espleni-02.6f807368.jpg";